export default {
  paged: {
    select: 'id,name,description,isActive,isPublic,isDefault,type',
    searchSelect: ['name', 'description'],
    orderBy: 'name',
  },
  item: {
    select: 'id,name,description,isActive,isPublic,isDefault,type',
  },
  itemDetail: {
    select: 'id,name,description,isActive,isPublic,isDefault,type,created,updated',
    expand: {
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
